import { ApiError } from './api-error';

export class UnprocessableEntityError extends ApiError {}
